var render = function render(){
  var _vm$selectItem;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "800",
      "title": `${_vm.openedSalesOrder ? '编辑' : '新增'}销售订单`
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('Modal', {
    attrs: {
      "width": "800",
      "footer-hide": ""
    },
    model: {
      value: _vm.isShowchooseRecipeModal,
      callback: function ($$v) {
        _vm.isShowchooseRecipeModal = $$v;
      },
      expression: "isShowchooseRecipeModal"
    }
  }, [_c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('div', {
    staticClass: "handle-left"
  }, [_vm._v(" 当前配方：" + _vm._s('#' + ((_vm$selectItem = _vm.selectItem) === null || _vm$selectItem === void 0 ? void 0 : _vm$selectItem.recipe.NoId) || "无") + " ")]), _c('div', {
    staticClass: "handle-right"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.recipetotalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.recipetotalRows,
      "page-size": 15,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadRecipe
    }
  })], 1)]), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.recipeSalesList,
      "height": _vm.tableHeight
    }
  })], 1)]), _c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-por5sition": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-item-wrap"
  }, [_c('div', {
    staticClass: "form-item-left",
    staticStyle: {
      "width": "320px"
    }
  }, [_c('h2', [_vm._v("订单列表")]), _vm.soList.length === 0 ? _c('div', [_vm._v(" 请在下列销售项目中选择 ")]) : _vm._e(), _vm._l(_vm.soList, function (so, index) {
    return _c('div', {
      key: index,
      staticClass: "sales-order-box"
    }, [_c('div', {
      staticClass: "del-icon"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-close",
        "size": "24"
      },
      on: {
        "click": function ($event) {
          return _vm.delSOList(index);
        }
      }
    })], 1), _c('div', [_c('h3', [_vm._v(_vm._s(so.sales.abbr))]), _c('div', {
      staticClass: "so-recipe-row",
      on: {
        "click": function ($event) {
          return _vm.openChooseRecipe('create', so, index);
        }
      }
    }, [_c('h4', {
      staticStyle: {
        "margin-right": "12px"
      }
    }, [_vm._v("配方：")]), so.recipe ? _c('div', {
      staticClass: "recipe"
    }, [_vm._v(" " + _vm._s('#' + so.recipe.NoId + '（' + so.recipe.name + '）') + " ")]) : _c('div', {
      staticClass: "recipe"
    })]), _c('FormItem', {
      attrs: {
        "label": "数量：",
        "prop": "volPlan"
      }
    }, [_c('InputNumber', {
      model: {
        value: so.volPlan,
        callback: function ($$v) {
          _vm.$set(so, "volPlan", $$v);
        },
        expression: "so.volPlan"
      }
    }), _vm._v(" 吨 ")], 1), _c('div', {
      staticClass: "option-cell-list",
      staticStyle: {
        "width": "100%",
        "margin-top": "20px",
        "height": "30px"
      }
    }, _vm._l(_vm.tonOption, function (d, tonIndex) {
      return _c('div', {
        key: tonIndex,
        class: {
          'option-cell': true,
          selected: d.tonValue === so.volPlan
        },
        on: {
          "click": function ($event) {
            return _vm.tonClick(d.tonValue, index);
          }
        }
      }, [_vm._v(" " + _vm._s(d.name) + " ")]);
    }), 0)], 1)]);
  }), !_vm.editMode ? _c('Divider') : _vm._e(), !_vm.editMode ? _c('Input', {
    attrs: {
      "search": "",
      "clearable": "",
      "placeholder": "搜索销售项目...",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.getRecommendSalesOrderMethod
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }) : _vm._e(), !_vm.editMode ? _c('div', [_c('Row', {
    staticStyle: {
      "margin-top": "4px",
      "padding": "4px 0",
      "border-bottom": "1px solid #ececec"
    }
  }, [_c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_vm._v(" 评审 ")]), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_vm._v(" 审单 ")]), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_vm._v(" 限供 ")]), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_vm._v(" 销售项目 ")])], 1), _vm._l(_vm.soRecommendList, function (so) {
    return _c('div', {
      on: {
        "click": function ($event) {
          return _vm.selectSales(so);
        }
      }
    }, [_c('Row', {
      staticClass: "sales-row"
    }, [_c('Col', {
      attrs: {
        "span": "3"
      }
    }, [so.allowSales ? _c('Icon', {
      attrs: {
        "type": "md-checkmark",
        "size": "24",
        "color": "lightgreen"
      }
    }) : _c('Icon', {
      attrs: {
        "type": "md-close",
        "size": "24",
        "color": "pink"
      }
    })], 1), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_vm._v(" " + _vm._s(so.prePaidOnly ? '需要' : '-') + " ")]), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_vm._v(" " + _vm._s(so.isLimitVolPerMonth ? so.limitVolPerMonth : '-') + " ")]), _c('Col', {
      attrs: {
        "span": "15"
      }
    }, [_vm._v(" " + _vm._s(so.abbr) + " ")])], 1)], 1);
  })], 2) : _vm._e()], 2), _c('div', {
    staticClass: "form-item-right",
    staticStyle: {
      "width": "420px"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "抵达时间"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "180px",
      "margin-bottom": "20px",
      "float": "left"
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "arrivedAtDate"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "150px",
      "margin-right": "16px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: _vm.formItem.arrivedAtDate,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "arrivedAtDate", $$v);
      },
      expression: "formItem.arrivedAtDate"
    }
  })], 1)], 1), _c('div', {
    staticStyle: {
      "width": "150px",
      "margin-bottom": "20px",
      "float": "left"
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "arrivedAtTime"
    }
  }, [_c('TimePicker', {
    staticStyle: {
      "width": "112px"
    },
    attrs: {
      "format": "HH:mm",
      "placeholder": "选择时间"
    },
    model: {
      value: _vm.formItem.arrivedAtTime,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "arrivedAtTime", $$v);
      },
      expression: "formItem.arrivedAtTime"
    }
  })], 1)], 1), _c('div', {
    staticClass: "option-cell-list",
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    }
  }, _vm._l(_vm.dateOption, function (d, index) {
    return _c('div', {
      key: index,
      class: {
        'option-cell': true,
        selected: d.addDates === _vm.dateOptionValue
      },
      on: {
        "click": function ($event) {
          return _vm.dateClick(d.addDates);
        }
      }
    }, [_vm._v(" " + _vm._s(d.name) + " ")]);
  }), 0), _c('div', {
    staticClass: "option-cell-list"
  }, _vm._l(_vm.timeOption, function (t, index) {
    return _c('div', {
      key: index,
      class: {
        'option-cell': true,
        selected: t.time === _vm.formItem.arrivedAtTime
      },
      on: {
        "click": function ($event) {
          return _vm.timeClick(t);
        }
      }
    }, [_vm._v(" " + _vm._s(t.time) + " ")]);
  }), 0)]), _c('FormItem', {
    attrs: {
      "label": "车俩"
    }
  }), _c('div', {
    staticClass: "vehicle-cell-list"
  }, [_vm._l(_vm.vehicleDisplayList, function (c, index) {
    return _c('div', {
      key: c._id,
      class: {
        'vehicle-option-cell': true,
        selected: c._id === _vm.formItem.delivery.vehicle
      },
      on: {
        "click": function ($event) {
          return _vm.vehicleClick(c, 'vehicle');
        }
      }
    }, [_vm._v(" " + _vm._s(c.plate) + " ")]);
  }), !_vm.showAllVehicle ? _c('div', {
    staticClass: "tool-btn",
    on: {
      "click": function ($event) {
        _vm.showAllVehicle = true;
      }
    }
  }, [_vm._v("显示全部")]) : _c('div', {
    staticClass: "tool-btn",
    on: {
      "click": function ($event) {
        _vm.showAllVehicle = false;
      }
    }
  }, [_vm._v("隐藏多余")])], 2), _c('FormItem', {
    attrs: {
      "label": "司机"
    }
  }), _c('div', {
    staticClass: "vehicle-cell-list"
  }, _vm._l(_vm.userList, function (c, index) {
    return _c('div', {
      key: c._id,
      class: {
        'vehicle-option-cell': true,
        selected: c._id === _vm.formItem.delivery.driver
      },
      on: {
        "click": function ($event) {
          return _vm.vehicleClick(c, 'driver');
        }
      }
    }, [_vm._v(" " + _vm._s(c.name) + " ")]);
  }), 0), _c('FormItem', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入备注"
    },
    model: {
      value: _vm.formItem.remark,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "remark", $$v);
      },
      expression: "formItem.remark"
    }
  })], 1)], 1)])])], 1), _c('div', {
    staticClass: "footer"
  }, [_c('Button', {
    staticStyle: {
      "width": "150px",
      "margin-left": "12px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }